var pageItem = `<div class="page-item item">
    <a href="" class="remove-page-item-trigger remove-item-trigger icon-trash" tabindex="-1"></a>
    <a href="" class="add-page-item-trigger-before add-item-before-trigger icon-add" tabindex="-1"></a>

    <ul class="fields no-padding">
        <li>
            <input type="tel" name="page_number[]" class="required">
            <span>Page Number</span>
        </li>

        <li>
            <textarea name="html[]" class="required"></textarea>
            <span>HTML</span>
        </li>

        <li>
            <textarea name="css[]" class="required"></textarea>
            <span>CSS</span>
        </li>
    </ul>
</div>`;

$('body').on('click', '.add-page-item-trigger', function () {
    var $this = $(this);
    var modal = $this.parents('.modal');
    modal.find('.setup-page-items').append(pageItem);
    return false;
});

$('body').on('click', '.add-page-item-trigger-before', function () {
    var $this = $(this);
    $this.parents('.page-item').before(pageItem);
    return false;
});

$('body').on('click', '.remove-page-item-trigger', function () {
    var $this = $(this);
    $this.parents('.page-item').remove();
    return false;
});

$('body').on('click', '.add-email-template-trigger', function() {
    openModal('.add-email-template');
    return false;
});

$("body").on("click", ".open-email-template-menu", function () {
    var $this = $(this);
    var menu = $this.parents(".email-template-menu-wrapper");

    $(".email-template-menu", menu).css({
        top: menu.position().top,
        left:
            5 + (menu.position().left + menu.width()) - $(".email-template-menu", menu).width()
    });

    menu.addClass("opened");
    closeDropdown($this.parents(".email-template-menu-wrapper").attr("data-dropdown"));
    return false;
});

$('body').on('click', '.edit-email-template-trigger', function() {
    var data = $(this).parents('.email-template');
    var action = $('.edit-email-template form').attr('data-action').replace('{email_template}', data.attr('data-email_template'));
    $('.edit-email-template form').attr('action', action);

    $('.edit-email-template input[name="name"]').val(data.attr('data-name'));
    $('.edit-email-template input[name="from_name"]').val(data.attr('data-from_name'));
    $('.edit-email-template input[name="from_email"]').val(data.attr('data-from_email'));
    $('.edit-email-template input[name="subject"]').val(data.attr('data-subject'));
    $('.edit-email-template textarea[name="body"]').val(data.attr('data-body'));
    $('.edit-email-template [name="design"]').val(data.attr('data-design'));

    fileUploaderRemoveFile($('.edit-email-template .file-uploader[data-file="pdf_template"]'));
    if (data.attr('data-pdf_template')) {
        fileUploaderAddFile($('.edit-email-template .file-uploader[data-file="pdf_template"]'), data.attr('data-pdf_template_name'), data.attr('data-pdf_template'));
    }

    // setup pages
    var pages = JSON.parse(data.attr('data-pages'));
    // clear out the page items
    $('.edit-email-template .setup-page-items').html('');
    // append in page items
    $.each(pages, function (index, pageItem) {
        $('.edit-email-template .setup-page-items').append(`<div class="page-item item">
            <a href="" class="remove-page-item-trigger remove-item-trigger icon-trash" tabindex="-1"></a>
            <a href="" class="add-page-item-trigger-before add-item-before-trigger icon-add" tabindex="-1"></a>

            <ul class="fields no-padding">
                <li class="filled">
                    <input type="tel" name="page_number[]" class="required" value="${pageItem.page_number}">
                    <span>Page Number</span>
                </li>

                <li class="filled">
                    <textarea name="html[]" class="required">${pageItem.html}</textarea>
                    <span>HTML</span>
                </li>

                <li class="filled">
                    <textarea name="css[]" class="required">${pageItem.css}</textarea>
                    <span>CSS</span>
                </li>
            </ul>
        </div>`);
    });

    closeDropdown();
    openModal('.edit-email-template');
    return false;
});

$('body').on('click', '.copy-email-template-trigger', function () {
    var data = $(this).parents('.email-template');

    $('.add-email-template input[name="name"]').val(data.attr('data-name'));
    $('.add-email-template input[name="from_name"]').val(data.attr('data-from_name'));
    $('.add-email-template input[name="from_email"]').val(data.attr('data-from_email'));
    $('.add-email-template input[name="subject"]').val(data.attr('data-subject'));
    $('.add-email-template textarea[name="body"]').val(data.attr('data-body'));
    $('.add-email-template [name="design"]').val(data.attr('data-design'));


    fileUploaderRemoveFile($('.add-email-template .file-uploader[data-file="pdf_template"]'));
    if (data.attr('data-pdf_template_name')) {
        fileUploaderAddFile($('.add-email-template .file-uploader[data-file="pdf_template"]'), data.attr('data-pdf_template_name'), data.attr('data-pdf_template'));
    }

    // setup pages
    var pages = JSON.parse(data.attr('data-pages'));
    // clear out the page items
    $('.add-email-template .setup-page-items').html('');
    // append in page items
    $.each(pages, function (index, pageItem) {
        $('.add-email-template .setup-page-items').append(`<div class="page-item item">
            <a href="" class="remove-page-item-trigger remove-item-trigger icon-trash" tabindex="-1"></a>
            <a href="" class="add-page-item-trigger-before add-item-before-trigger icon-add" tabindex="-1"></a>

            <ul class="fields no-padding">
                <li class="filled">
                    <input type="tel" name="page_number[]" class="required" value="${pageItem.page_number}">
                    <span>Page Number</span>
                </li>

                <li class="filled">
                    <textarea name="html[]" class="required">${pageItem.html}</textarea>
                    <span>HTML</span>
                </li>

                <li class="filled">
                    <textarea name="css[]" class="required">${pageItem.css}</textarea>
                    <span>CSS</span>
                </li>
            </ul>
        </div>`);
    });

    closeDropdown();
    openModal('.add-email-template');
    return false;
});

$('body').on('submit', '.add-email-template form, .edit-email-template form', function() {
    var $this = $(this);
    var modal = $this.parents('.modal');
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;

    modal.find('.required').each(function() {
        if($(this).val() === '') {
            error = true;
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            // console.log(data);
            unloading();

            if(!data.success) {
                showError('Error', data.message);
                return false;
            }

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});

channel.bind('process-email-template', function(data) {
    // console.log(data);
    var template;

    if($('.email-template[data-email_template="'+data.email_template+'"]').length) {
        template = $('.email-template[data-email_template="'+data.email_template+'"]');
        template.attr('data-name', data.name);
        template.attr('data-from_name', data.from_name);
        template.attr('data-from_email', data.from_email);
        template.attr('data-subject', data.subject);
        template.attr('data-body', data.body);
        template.attr('data-design', data.design);

        template.attr('data-pdf_template', data.pdf_template);
        template.attr('data-pdf_template_name', data.pdf_template_name);
        template.attr('data-pdf_template_file_name', data.pdf_template_file_name);
        template.attr('data-pages', JSON.stringify(data.pages));

        template.find('[data-input="name"]').html(data.name);
        template.find('[data-input="design"]').html(data.design);
        template.find('[data-input="from_name"]').html(data.from_name);
        template.find('[data-input="from_email"]').html(data.from_email);
        template.find('[data-input="subject"]').html(data.subject);
        template.find('[data-input="date_added"]').html(data.date_added);

        template.find('.email-template-menu').html(buttons(data.buttons));
        return;
    }

    if($('body').attr('data-page') === '1') {
        template = $('<tr>', {
            class: 'email-template',
            'data-email_template': data.email_template,
            'data-name': data.name,
            'data-from_name': data.from_name,
            'data-from_email': data.from_email,
            'data-subject': data.subject,
            'data-body': data.body,
            'data-design': data.design,
            'data-pdf_template': data.pdf_template,
            'data-pdf_template_name': data.pdf_template_name,
            'data-pdf_template_file_name': data.pdf_template_file_name,
            'data-pages': JSON.stringify(data.pages)
        });

        template.append(`<td>
            <p data-input="name">${data.name}</p>
            <p class="small-text" data-input="design">${data.design}</p>
        </td>
        <td data-input="from_name">${data.from_name}</td>
        <td data-input="from_email">${data.from_email}</td>
        <td data-input="subject">${data.subject}</td>
        <td data-input="date_added">${data.date_added}</td>
        <td class="email-template-menu-wrapper menu-wrapper" data-dropdown="email-template-${data.email_template}">
            <a href="" class="icon-more open-email-template-menu open-menu"></a>
            <ul class="email-template-menu menu">
                ${buttons(data.buttons)}
            </ul>
        </td>`);

        $('.email-templates tbody').prepend(template);
    }
});